export default function removeObjectWithChildren(object) {
    /**
     * This function removes an object from the scene and disposes of its geometry and material
     * @param {THREE.Object3D}
     * @returns {void}
     */

    if (!object) return

    for (let i = object.children.length - 1; i >= 0; i--) {
        removeObjectWithChildren(object.children[i])
    }
    object.parent?.remove(object)
    if (object.geometry) object.geometry.dispose()
    if (object.material) object.material.dispose()
    if (object.texture) object.texture.dispose()
    if (object.element) object.element.remove()
}